export default __webpack_public_path__ + "static/media/icon_firebase.24c36821.png";